<template>
  <model-table
    :collection="locations"
    :orderable="true"
    :columns="[
      { field: 'id' },
      { field: 'name' },
      { label: 'Printer', field: 'resolvedPrinter', component: 'model' },
      { name: 'inventoryDefault', field: isInventoryDefaultLocation, component: 'checkmark' },
      { field: 'locationGroup', component: 'model' },
      { name: 'actions', label: 'Action', align: 'right' }
    ]"
  >
    <location-form />
  </model-table>
</template>

<script>

import ModelTable from 'src/modules/admin/components/ModelTable'
import LocationForm from 'src/modules/admin/location/LocationForm'

export default {
  name: 'LocationTable',
  components: {
    ModelTable,
    LocationForm
  },
  configuration: ['currentCircuit', 'currentSite'],
  models: {
    locations: {
      printer: {
        fields: ['id', 'name']
      },
      kitchenDisplay: {
        fields: ['id', 'name']
      },
      registerStation: {
        fields: ['id', 'name']
      },
      locationGroup: {
        fields: ['id', 'name']
      }
    }
  },
  methods: {
    isInventoryDefaultLocation (location) {
      if (!this.currentSite.activeInventoryStrategy) {
        return false
      }

      return this.currentSite.activeInventoryStrategy.defaultInventoryLocationId === location.id
    }
  }
}
</script>
